import script from "./ExploreButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExploreButton.vue?vue&type=script&setup=true&lang=ts"

import "./ExploreButton.vue?vue&type=style&index=0&id=228585e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228585e4"]])

export default __exports__